import { A, useParams } from "@solidjs/router";
import { For } from "solid-js";
import { AplombButton, AplombChip, AplombScoreBadge } from "~/components";
import "./match.css";


// V1 : mock data. V1.1 : brancher GET /v1/requests/{id}/proposals.
interface Proposition {
  id: string;
  business_name: string;
  score: number;
  score_source: string;
  amount_cad: number;
  eta_arrival_min: number;
  covered_zones: string[];
  guarantees: string[];
}

const MOCK_PROPOSITIONS: Proposition[] = [
  {
    id: "prop_01",
    business_name: "Plomberie Rive-Sud SENC",
    score: 87,
    score_source: "8 composantes (ADR-0007) — 42 projets vérifiés",
    amount_cad: 285.0,
    eta_arrival_min: 45,
    covered_zones: ["H2X", "H2Y", "H2Z"],
    guarantees: ["Vice caché 12 mois", "Caution 500 $"],
  },
  {
    id: "prop_02",
    business_name: "Aquapro Montréal Est inc.",
    score: 79,
    score_source: "8 composantes (ADR-0007) — 28 projets vérifiés",
    amount_cad: 315.0,
    eta_arrival_min: 30,
    covered_zones: ["H2X", "H1V"],
    guarantees: ["Vice caché 12 mois", "Caution 500 $"],
  },
];

function formatMoney(cad: number): string {
  // Format QC OQLF : 1 234,56 $ (espace fine insécable + virgule)
  return new Intl.NumberFormat("fr-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
  })
    .format(cad)
    .replace(/ /g, " "); // fine insécable
}

export default function Match() {
  const params = useParams<{ id: string }>();
  const requestId = () => params.id;

  return (
    <>
      <header class="a-nav">
        <div class="a-container a-nav__inner">
          <A href="/" class="a-nav__brand">
            <span class="a-nav__brandmark">A|</span>
            <span class="a-nav__brandtext">Aplomb</span>
          </A>
          <A href="/" class="a-nav__back">← Accueil</A>
        </div>
      </header>

      <main class="a-container a-match">
        <p class="a-match__crumbs">
          Demande <span class="a-match__id">{requestId()}</span>
        </p>
        <h1>Comparer les propositions</h1>
        <p class="a-match__intro">
          Les plombiers ci-dessous ont été vérifiés par notre équipe. Aucun classement payé —
          l'ordre reflète la disponibilité et le score composite, jamais un rang publicitaire.
        </p>

        <ul class="a-match__list">
          <For each={MOCK_PROPOSITIONS}>
            {(prop) => (
              <li class="a-match__card">
                <div class="a-match__header">
                  <div>
                    <h2>{prop.business_name}</h2>
                    <p class="a-match__meta">
                      Disponible dans <strong>{prop.eta_arrival_min} min</strong> — zones{" "}
                      {prop.covered_zones.join(", ")}
                    </p>
                  </div>
                  <AplombScoreBadge score={prop.score} source={prop.score_source} size="compact" />
                </div>

                <div class="a-match__guarantees">
                  <For each={prop.guarantees}>
                    {(g) => <AplombChip variant="conforming" compact>{g}</AplombChip>}
                  </For>
                </div>

                <div class="a-match__pricing">
                  <div>
                    <span class="a-match__amount">{formatMoney(prop.amount_cad)}</span>
                    <span class="a-match__amount-hint"> tout inclus TPS+TVQ</span>
                  </div>
                  <div class="a-match__actions">
                    <AplombButton variant="tertiary" size="compact">
                      Voir le détail
                    </AplombButton>
                    <AplombButton
                      variant="primary"
                      size="compact"
                      cost={`et déposer ${formatMoney(prop.amount_cad)} en escrow`}
                    >
                      Accepter
                    </AplombButton>
                  </div>
                </div>
              </li>
            )}
          </For>
        </ul>

        <section class="a-match__reassurance">
          <h3>Vos protections</h3>
          <ul>
            <li>L'argent reste en escrow jusqu'à ce qu'un inspecteur indépendant valide le travail.</li>
            <li>Vice caché couvert 12 mois par la caution du pro (500 $).</li>
            <li>
              Aucune réponse dans 24h ? Aplomb vous rembourse et vous recontacte avec d'autres pros.
            </li>
          </ul>
        </section>
      </main>
    </>
  );
}
